import React from 'react';

class NotFoundPage extends React.Component {

  render() {
    return (
      <div>
        <h1>404 - Page Not Found</h1>
        <div style={{ textAlign: 'center' }}>
          <a href='/'>Home</a>
        </div>
      </div>
    );
  }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/pages/NotFoundPage.js